<form [formGroup]="form">
  <mat-form-field class="item">
    <mat-label>
      {{ 'CREATE_BUSSINESS_USER_PAGE.FIRST_NAME' | translate }}
    </mat-label>
    <input matInput formControlName="first_name" autocomplete="false" />
  </mat-form-field>

  <mat-form-field class="item">
    <mat-label>
      {{ 'CREATE_BUSSINESS_USER_PAGE.LAST_NAME' | translate }}
    </mat-label>
    <input matInput formControlName="last_name" autocomplete="false" />
  </mat-form-field>

  <glxy-phone-input class="item" [formControl]="form.controls.phone" [required]="false"></glxy-phone-input>

  <mat-form-field class="item">
    <mat-label>
      {{ 'CREATE_BUSSINESS_USER_PAGE.USER_EMAIL' | translate }}
    </mat-label>
    <input matInput data-testid="user-email" formControlName="user_email" />
  </mat-form-field>

  <mat-form-field class="item">
    <mat-label>{{ 'CREATE_BUSSINESS_USER_PAGE.CORRESPONDENCE_LANGUAGE' | translate }}</mat-label>
    <mat-select formControlName="languages">
      <mat-option *ngFor="let l of emailLanguages" [value]="l">
        {{ l.label }}
      </mat-option>
    </mat-select>
    <mat-hint>
      {{ 'CREATE_BUSSINESS_USER_PAGE.LANGUAGE_HINT' | translate }}
    </mat-hint>
  </mat-form-field>

  <mat-form-field class="item">
    <mat-label>{{ 'CREATE_BUSSINESS_USER_PAGE.GREETING_NAME' | translate }}</mat-label>
    <input matInput formControlName="greeting_name" autocomplete="false" />
    <mat-hint>
      {{ 'CREATE_BUSSINESS_USER_PAGE.GREETING_NAME_HINT' | translate }}
    </mat-hint>
  </mat-form-field>

  <div class="preview-field">
    <glxy-checkbox class="toggle-preview" [formControl]="form.controls.send_welcome_email">
      {{ 'CREATE_BUSSINESS_USER_PAGE.WELCOME_MESSAGE_FLAG' | translate }}
    </glxy-checkbox>

    <a *ngIf="form.value.send_welcome_email === true" mat-stroked-button (click)="openPreviewEmail()">
      {{ 'CREATE_BUSSINESS_USER_PAGE.PREVIEW' | translate }}
    </a>
  </div>

  <ng-container *ngIf="form.controls.send_welcome_email.value">
    <mat-form-field class="item">
      <mat-label>
        {{ 'CREATE_BUSSINESS_USER_PAGE.WELCOME_MESSAGE' | translate }}
      </mat-label>
      <textarea
        matInput
        formControlName="custom_welcome_message"
        matTextareaAutosize="true"
        matAutosizeMinRows="2"
        matAutosizeMaxRows="5"
      ></textarea>
    </mat-form-field>
  </ng-container>
</form>
